export enum SEARCH_PAGE {
    /**
     * @value Did you mean %QUERY%?
     * @description Suggestion message to help the user to fix their query
     */
    DID_YOU_MEAN = 'FRONT.SEARCH.DID_YOU_MEAN',
    /**
     * @value Connect to %CONNECTOR% to search this content.
     */
    EXTENSION_CONNECTOR_MESSAGE = 'SEARCH.EXTENSION_CONNECTOR_MESSAGE',
    /**
     * @value You are not connected to %CONNECTOR%. Please connect to access content.
     * @description Displayed on search page error page when a user is not connected to a connector, preventing them to fetch search results
     */
    EXTENSION__CONNECTOR_ERROR_DESC = 'SEARCH.EXTENSION_CONNECTOR_ERROR_DESC',
    /**
     * @value Try later or contact your administrator.
     * @description Description of the error when search extension bundle could not be retrieved
     */
    EXTENSION__EXTENSION_ERROR_DESC = 'SEARCH.EXTENSION_MARKETPLACE_DESC',
    /**
     * @value Cannot access the search extension
     * @description Title of the error displayed when extension bundle could not be downloaded
     */
    EXTENSION__EXTENSION_ERROR_TITLE = 'SEARCH.EXTENSION_MARKETPLACE_ERROR_TITLE',
    /**
     * @value Try later or contact your administrator to check the search extension settings.
     * @description Error description displayed when search results could not be downloaded due to search extension settings issues
     */
    EXTENSION__FETCH_ERROR_DESC = 'SEARCH.EXTENSION_FETCH_ERROR_DESC',
    /**
     * @value Cannot retrieve the search results
     * @description Error title displayed when search results could not be displayed due to error in search extension settings
     */
    EXTENSION__FETCH_ERROR_TITLE = 'SEARCH.EXTENSION_FETCH_ERROR_TITLE',
    /**
     * @value Extension error
     */
    EXTENSION__GLOBAL_ERROR = 'SEARCH.EXTENSION_GLOBAL_ERROR',
    /**
     * @value Impossible to load and execute the extension
     */
    EXTENSION__GLOBAL_ERROR_DESCRIPTION = 'SEARCH.EXTENSION__GLOBAL_ERROR_DESCRIPTION',
    /**
     * @value How would you characterize these search results?
     * @description Displayed above text field area if the user clicks on dislike icon in the search result feedback section
     */
    FEEDBACK_COMMENT = 'SEARCH.FEEDBACK_COMMENT',
    /**
     * @value Your feedback helps enhance the search experience.
     */
    FEEDBACK_SUBTITLE = 'SEARCH.FEEDBACK_SUBTITLE',
    /**
     * @value Are these results helpful?
     */
    FEEDBACK_TITLE = 'SEARCH.FEEDBACK_TITLE',
    /**
     * @value Results
     * @description section title for classic search results
     */
    OTHER_RESULTS = 'FRONT.SEARCH.OTHER_RESULTS',
    /**
     * @value Promoted results
     * @description section title for promoted results
     */
    PROMOTED_RESULTS = 'FRONT.SEARCH.PROMOTED_RESULTS',
    /**
     * @value %COUNT% results for %QUERY%
     * @description title used to explain results on the search page
     */
    RESULTS_TITLE = 'FRONT.SEARCH.RESULTS_TITLE',
    /**
     * @value Search results for %QUERY%
     */
    SEARCH_RESULTS_FOR = 'SEARCH_PAGE.SEARCH_RESULTS_FOR',
}
